module.exports = __webpack_public_path__ + "img/part1.94be363f.jpg";